import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { IconComponent } from '../../../components/icon/icon.component';
import { AnalyticsContextComponent } from '../../analytics/analytics-context.component';
import { NotificationsToastComponent } from '../notifications-toast.domain';
import { ToastMessage } from './toast-message.domain';

@Component({
  templateUrl: 'toast-message.component.html',
  styleUrls: ['toast-message.component.scss'],
  imports: [
    AnalyticsContextComponent,
    IconComponent
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ToastMessageComponent implements NotificationsToastComponent {
  @Input() toast: ToastMessage;
}
